// extracted by mini-css-extract-plugin
export default {"container":"_2YfFIwutf32qH1-7k06x5G","badge":"_2lCeRguWcMVuwg8kipl_X2","icon":"_1gYXg7uXroGgLl5yVCnB7s"};